import styled from "styled-components";


export const RideAcceptedContentContainer = styled.div`
    display: table-cell;
    vertical-align: middle;
    padding-top: 6px;
    padding-bottom: 5px;
`;


// WEBPACK FOOTER //
// ./src/Components/Screen/Ride/RideAccepted/RideAcceptedStyle.js